




























































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import MonitoringTrombolisisSvc from "@/services/MonitoringTrombolisisService";
import { appModule } from "@/store/modules/app";
import moment from "moment";

@Component({
  inject: { isReadOnly: { default: () => () => false } }
})
export default class MonitoringTrombolisisLogDialog extends Vue {
  @Prop({ default: false }) value!: boolean;
  @Prop() monitoringId!: number;
  @Prop({ default: null }) bolusAt!: string;
  @Prop({ default: null }) editLog!: any;
  @Prop({ default: null }) prefillWaktu!: string;

  isReadOnly!: () => boolean;
  get readOnly(): boolean {
    return this.isReadOnly();
  }

  valid = true;
  saving = false;

  form: any = this.defaultForm();

  kesadaranOptions = ["Composmentis", "Apatis", "Somnolen", "Sopor", "Koma", "Tidak Terkaji"];
  bicaraOptions = ["Normal", "Disartria", "Afasia", "Tidak bisa"];

  rules = {
    required: (v: any) => !!v || "Wajib diisi",
  };

  get dialogVisible() {
    return this.value;
  }

  set dialogVisible(val: boolean) {
    this.$emit("input", val);
  }

  get isEdit() {
    // "Salin TTV Sebelumnya" mengirim objek log dgn id: undefined — itu BUKAN edit,
    // melainkan log baru. Tanpa cek id, addLog salah jadi updateLog(.../log/undefined) → 404.
    return !!(this.editLog && this.editLog.id);
  }

  get showTdAlert() {
    return (this.form.td_sistolik >= 180) || (this.form.td_diastolik >= 105);
  }

  get tdAlertColor() {
    return this.showTdAlert ? "#FFCDD2" : "";
  }

  get gcsTotal() {
    if (this.form.gcs_e && this.form.gcs_v && this.form.gcs_m) {
      return this.form.gcs_e + this.form.gcs_v + this.form.gcs_m;
    }
    return "-";
  }

  get menitDariBolus() {
    if (!this.bolusAt || !this.form.waktu) return null;
    const bolus = moment(this.bolusAt);
    const waktu = moment(this.form.waktu);
    return waktu.diff(bolus, "minutes");
  }

  @Watch("value")
  onOpen(val: boolean) {
    if (val) {
      if (this.editLog) {
        this.populateFromEdit();
      } else {
        this.form = this.defaultForm();
        if (this.prefillWaktu) {
          this.form.waktu = this.prefillWaktu.substring(0, 16);
        } else {
          this.form.waktu = moment().format("YYYY-MM-DDTHH:mm");
        }
      }
    }
  }

  defaultForm() {
    return {
      waktu: "",
      td_sistolik: null,
      td_diastolik: null,
      nadi: null,
      rr: null,
      spo2: null,
      suhu: null,
      nihss_score: null,
      kesadaran: null,
      gcs_e: null,
      gcs_v: null,
      gcs_m: null,
      pupil_kiri: null,
      pupil_kanan: null,
      motorik_kiri: null,
      motorik_kanan: null,
      bicara: null,
      tanda_perdarahan: false,
      tanda_perdarahan_text: null,
      tindakan_dilakukan: null,
    };
  }

  populateFromEdit() {
    const l = this.editLog;
    this.form = {
      waktu: l.waktu ? l.waktu.substring(0, 16) : "",
      td_sistolik: l.td_sistolik,
      td_diastolik: l.td_diastolik,
      nadi: l.nadi,
      rr: l.rr,
      spo2: l.spo2,
      suhu: l.suhu,
      nihss_score: l.nihss_score,
      kesadaran: l.kesadaran,
      gcs_e: l.gcs_e,
      gcs_v: l.gcs_v,
      gcs_m: l.gcs_m,
      pupil_kiri: l.pupil_kiri,
      pupil_kanan: l.pupil_kanan,
      motorik_kiri: l.motorik_kiri,
      motorik_kanan: l.motorik_kanan,
      bicara: l.bicara,
      tanda_perdarahan: l.tanda_perdarahan || false,
      tanda_perdarahan_text: l.tanda_perdarahan_text,
      tindakan_dilakukan: l.tindakan_dilakukan,
    };
  }

  close() {
    this.dialogVisible = false;
  }

  async simpan() {
    if (this.readOnly) return;
    const formRef = this.$refs.form as any;
    if (!formRef.validate()) return;

    this.saving = true;
    try {
      let resp;
      if (this.isEdit) {
        resp = await MonitoringTrombolisisSvc.updateLog(this.monitoringId, this.editLog.id, this.form);
      } else {
        resp = await MonitoringTrombolisisSvc.addLog(this.monitoringId, this.form);
      }

      if (resp?.data?.status == "1") {
        // Show alerts if any
        if (resp.data.alerts && resp.data.alerts.length > 0) {
          resp.data.alerts.forEach((alert: string) => {
            appModule.NoticeDelay(alert);
          });
        } else {
          appModule.NoticeDelay(this.isEdit ? "Log berhasil diperbarui" : "Log berhasil dicatat");
        }
        this.$emit("saved");
        this.close();
      }
    } catch {
      // handled by service
    }
    this.saving = false;
  }
}
